import { createSelector } from '@reduxjs/toolkit';
import { DependencyArtifact } from 'gql/DependencyArtifacts';
import { RootState } from 'store/RootReducer';
import { DependencyArtifactsState } from './DependencyArtifactsSlice';

const selectDependencyArtifacts = createSelector(
  (state: RootState) => state.dependencyArtifacts,
  (dependencyArtifactsState: DependencyArtifactsState): DependencyArtifact[] => {
    return dependencyArtifactsState.dependencyArtifacts;
  }
);

const DependencyArtifactsSelectors = {
  selectDependencyArtifacts,
};

export default DependencyArtifactsSelectors;
